import React from "react";
import { Box } from "theme-ui";

const Footer = () => {
    return  (<Box sx={{ color: "white", px: [0, 60, 130] }}>
    © {new Date().getFullYear()}, nullgravity
  </Box>);
};

export default Footer;